/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InboxMessageOnAzure
 */
export interface InboxMessageOnAzure {
    /**
     * 
     * @type {string}
     * @memberof InboxMessageOnAzure
     */
    header: string;
    /**
     * 
     * @type {string}
     * @memberof InboxMessageOnAzure
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof InboxMessageOnAzure
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InboxMessageOnAzure
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof InboxMessageOnAzure
     */
    language_code: string;
    /**
     * 
     * @type {string}
     * @memberof InboxMessageOnAzure
     */
    object_type: string;
    /**
     * 
     * @type {string}
     * @memberof InboxMessageOnAzure
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof InboxMessageOnAzure
     */
    _etag: string;
    /**
     * 
     * @type {number}
     * @memberof InboxMessageOnAzure
     */
    _ts: number;
}

/**
 * Check if a given object implements the InboxMessageOnAzure interface.
 */
export function instanceOfInboxMessageOnAzure(value: object): value is InboxMessageOnAzure {
    if (!('header' in value) || value['header'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('language_code' in value) || value['language_code'] === undefined) return false;
    if (!('object_type' in value) || value['object_type'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('_etag' in value) || value['_etag'] === undefined) return false;
    if (!('_ts' in value) || value['_ts'] === undefined) return false;
    return true;
}

export function InboxMessageOnAzureFromJSON(json: any): InboxMessageOnAzure {
    return InboxMessageOnAzureFromJSONTyped(json, false);
}

export function InboxMessageOnAzureFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboxMessageOnAzure {
    if (json == null) {
        return json;
    }
    return {
        
        'header': json['header'],
        'message': json['message'],
        'name': json['name'],
        'url': json['url'],
        'language_code': json['language_code'],
        'object_type': json['object_type'],
        'id': json['id'],
        '_etag': json['_etag'],
        '_ts': json['_ts'],
    };
}

export function InboxMessageOnAzureToJSON(json: any): InboxMessageOnAzure {
    return InboxMessageOnAzureToJSONTyped(json, false);
}

export function InboxMessageOnAzureToJSONTyped(value?: InboxMessageOnAzure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'header': value['header'],
        'message': value['message'],
        'name': value['name'],
        'url': value['url'],
        'language_code': value['language_code'],
        'object_type': value['object_type'],
        'id': value['id'],
        '_etag': value['_etag'],
        '_ts': value['_ts'],
    };
}

